// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3IE6W","info":"PatientInfo_info__n4Igr"};